import qs from 'qs';
import {http} from './index';
import {AnswerQaListApiTypes, AnswerQaConfSubjectTypes} from '@types';
const pathUrl = 'teaching-workbench/ask';
// [答疑数据统计-查询]
export const answerQaList = (params: AnswerQaListApiTypes) => http.post(`${pathUrl}/statistical/list`, params);
// [答疑数据统计-导出]
export const answerQaExport = (params: AnswerQaListApiTypes) => http.post(`${pathUrl}/statistical/export`, params, { responseType: 'blob'});
// [答疑数据统计-配置科目]
export const answerQaConfSubject = (params: AnswerQaConfSubjectTypes) => http.put(`${pathUrl}/configure/subject?${qs.stringify(params)}`);
// [实时数据统计-查询]
export const realtimeList = (params: AnswerQaListApiTypes) => http.post(`${pathUrl}/statistical/real-time`, params);
// [实时数据统计-导出]
export const realtimeExport = (params: AnswerQaListApiTypes) => http.post(`${pathUrl}/statistical/real-time/export`, params, { responseType: 'blob'});